import React from "react";
import style from "./Avatar.module.scss";

function Avatar({ size = "small", name = "N" }) {
  const getSizeClass = (size) => {
    if (size == "small") return style.small;
    if (size == "medium") return style.medium;
    if (size == "xs") return style.xs;
  };

  return (
    <span className={`${style.avatar} ${getSizeClass(size)}`}>{name}</span>
  );
}

export default Avatar;
